export default {
    methods: {
        $scrollTo(selector) {
            this.$nextTick(() => {
                const element = this.$el.querySelector(selector);
                if (element) {
                    element.scrollIntoView({behavior: 'smooth', block: 'center'});
                }
            });
        },
        $scrollToErrorField() {
            this.$scrollTo('.error')
        },
    }
}
